import { Route } from '@angular/router';
import { BreadcrumbService } from 'xng-breadcrumb';
import { Injectable } from '@angular/core';

/**
 * Extend the Angular Route with a breadcrumb name.
 */
export interface MyRoute extends Route {
    /** Friendly name for BreadcrumbService. Hide if not set. */
    breadcrumbName?: string;
}

/**
 * Extension of ngx-breadcrumb's BreadcrumbService to make setting friendly breadcrumb names more declarative.
 */
@Injectable()
export class MyBreadcrumbService {

    constructor(private breadcrumbSvc: BreadcrumbService) {
    }

    /**
     * Configure the BreadcrumbService.
     * @param baseRoutePath child route paths are relative to this path.
     * @param childRoutes {MyRoute[]}
     */
    public setBreadcrumbRouteNames(baseRoutePath: string, childRoutes: MyRoute[]) {
        for (let route of childRoutes) {
            let path = (route.path ? baseRoutePath + '/' + route.path : baseRoutePath).replace('//','/');
            if (route.data && route.data.alias) {
                this.breadcrumbSvc.set('@' + route.data.alias, route.breadcrumbName);
            } else {
                if (route.breadcrumbName) {
                    this.breadcrumbSvc.set(path, route.breadcrumbName);
                }
                else {
                    this.breadcrumbSvc.set(path, {skip: true});
                }
            }
        }
    }
}
